<div class="metadata-block">
    <div class="metadata-title">{{ getPrettyType() }} Properties</div>
    <div>
      <!-- <div class="metadata-key" id="name-test">{{ getPrettyType() }} Name</div> -->
        <!--<div class="metadata-value">{{data?.name}}</div>-->
    </div>
    <!--     
    <div>
        <p class="metadata-key">Type:</p>
        <p class="metadata-value">{{ getType() }}</p>
    </div> -->
   
        <div *ngIf="userService.isAdmin() && isFormIdEnabled && data?.id">
            <div class="metadata-key" >Id:</div>
            <div class="font-s">{{ data?.id }}</div>
        </div>
 
</div>
